/* eslint-disable no-shadow */

export enum MDICTypeEnum {
  NAO_ENVIAR_PARA_MDIC = 0,
  ENVIAR_PARA_MDIC = 1,
}

export const MDICTypeLabels: Record<number, string> = {
  [MDICTypeEnum.NAO_ENVIAR_PARA_MDIC]: "Não enviar para o MDIC",
  [MDICTypeEnum.ENVIAR_PARA_MDIC]: "Enviar para o MDIC",
};

export const MDICTypeList = [
  {
    value: MDICTypeEnum.NAO_ENVIAR_PARA_MDIC,
    label: MDICTypeLabels[MDICTypeEnum.NAO_ENVIAR_PARA_MDIC],
  },
  {
    value: MDICTypeEnum.ENVIAR_PARA_MDIC,
    label: MDICTypeLabels[MDICTypeEnum.ENVIAR_PARA_MDIC],
  },
];
